import api from '@shared/services/api';

export const companiesService = {
    // Get all companies/branches
    getAllCompanies: async () => {
        try {
            const response = await api.get('/emp-branches');
            return response.data;
        } catch (error) {
            console.error('Error fetching companies:', error);
            throw error;
        }
    },

    getNationalRevenue: async (id) => {
        try {
            const response = await api.get(`/hr-nssi-nomenclature/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching national revenue:', error);
            throw error;
        }
    },

    getBusinessQualification: async (id) => {
        try {
            const response = await api.get(`/nomenclatures/22?parentValue=${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching business qualification:', error);
            throw error;
        }
    },
    getNkpdHierarchy: async (value) => {
        try {
            const response = await api.get(`/nkid-hierarchy/${value}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching nkpd hierarchy:', error);
            throw error;
        }
    },

    getRootBusinessQualification: async () => {
        try {
            const response = await api.get('/nomenclatures/22');
            return response.data;
        } catch (error) {
            console.error('Error fetching root business qualification:', error);
            throw error;
        }
    },

    getSelectedCompany: async (id) => {
        try {
            const response = await api.get(`/emp-branches/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching selected company:', error);
            throw error;
        }
    },

    addCompany: async (companyData) => {
        try {
            const response = await api.post('/emp-branches', companyData);
            return response.data;
        } catch (error) {
            console.error('Error adding company:', error);
            throw error;
        }
    },

    // Update company/branch
    updateCompany: async (id, companyData) => {
        try {
            const response = await api.put(`/emp-branches/${id}`, companyData);
            return response.data;
        } catch (error) {
            console.error('Error updating company:', error);
            throw error;
        }
    },

    // Delete company/branch
    deleteCompany: async (id) => {
        try {
            const response = await api.delete(`/emp-branches/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting company:', error);
            throw error;
        }
    },

    addSigners: async (signersData) => {
        try {
            const response = await api.post(`/document-quality-signatory`, signersData);
            return response.data;
        } catch (error) {
            console.error('Error adding signers:', error);
            throw error;
        }
    },
    getSigners: async (id) => {
        try {
            const response = await api.get(`/document-quality-signatory/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching signers:', error);
            throw error;
        }
    },
    updateSigners: async (signersData) => {
        try {
            const response = await api.post(`/document-quality-signatory/upsert`, signersData);
            return response.data;
        } catch (error) {
            console.error('Error updating signers:', error);
            throw error;
        }
    },

    getBankAccounts: async (id) => {
        try {
            const response = await api.get(`/firm-bank-account/company/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching bank accounts:', error);
            throw error;
        }
    },

    // Get city details by ID (for postal code)
    getCityById: async (cityId) => {
        try {
            const response = await api.get(`/cities/${cityId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching city details:', error);
            throw error;
        }
    },

    // Get company centers/offices by branch ID
    getCompanyCenters: async () => {
        try {
            const response = await api.get(`/emp-office`);
            return response.data;
        } catch (error) {
            console.error('Error fetching company centers:', error);
            throw error;
        }
    },

    // Add new company center/office
    addCompanyCenter: async (centerData) => {
        try {
            const response = await api.post('/emp-office', centerData);
            return response.data;
        } catch (error) {
            console.error('Error adding company center:', error);
            throw error;
        }
    },

    // Update company center/office
    updateCompanyCenter: async (id, centerData) => {
        try {
            const response = await api.put(`/emp-office/${id}`, centerData);
            return response.data;
        } catch (error) {
            console.error('Error updating company center:', error);
            throw error;
        }
    },

    // Delete company center/office
    deleteCompanyCenter: async (id) => {
        try {
            const response = await api.delete(`/emp-office/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting company center:', error);
            throw error;
        }
    }
};
